import { motion } from "framer-motion";
import { HeartHandshake, PawPrint, GraduationCap, HandCoins, Flame } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const icons = [HeartHandshake, PawPrint, GraduationCap, HandCoins, Flame];
const spans = ["lg:col-span-2 lg:row-span-2", "", "", "", ""];
const featuredImg = "https://images.unsplash.com/photo-1604998268070-8d9b57c181ec";

export const Causes = () => {
  const { t } = useLang();
  const items = t("causes.items");

  return (
    <section id="causes" data-testid="causes-section" className="py-24 bg-secondary/15">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <p className="text-xs tracking-[0.3em] uppercase font-bold text-primary mb-5">{t("causes.overline")}</p>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-foreground leading-tight">
            {t("causes.title")}
          </h2>
        </div>

        <div className="grid lg:grid-cols-4 gap-6 auto-rows-[220px]">
          {items.map((c, i) => {
            const Icon = icons[i];
            const featured = i === 0;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.08 }}
                data-testid={`cause-card-${i}`}
                className={`group relative overflow-hidden rounded-2xl border border-border p-7 flex flex-col justify-between hover:-translate-y-1 transition-transform duration-300 ${spans[i]} ${featured ? "text-white" : "bg-card"}`}
              >
                {featured && (
                  <>
                    <img src={featuredImg} alt={c.title} className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-0" style={{ background: "hsl(160 38% 16% / 0.72)" }} />
                  </>
                )}
                <div className="relative z-10">
                  <Icon strokeWidth={1.5} className={featured ? "text-secondary" : "text-primary"} size={30} />
                </div>
                <div className="relative z-10">
                  <h3 className={`font-serif text-2xl mb-2 ${featured ? "text-white" : "text-foreground"}`}>{c.title}</h3>
                  <p className={`text-sm leading-relaxed ${featured ? "text-white/80" : "text-muted-foreground"}`}>{c.text}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
